export const USD_PER_INPUT_TOKEN = 0.0375 / 1000;
export const USD_PER_OUTPUT_TOKEN = 0.075 / 1000;
export const NUM_TOKEN_RESPONSE_AVG = 200;
export const GPT_MODEL = "gpt-4o";
export const HAIKU_MODEL = "claude-3-haiku-20240307";
export const SONNET_MODEL = "claude-3-sonnet-20240229";
export const OPUS_MODEL = "claude-3-opus-20240229";
export const CODE_ONLY_MODEL = "code-only";
export const GOOGLE_WEB_MODEL = "google-and-web";